/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FxIdWebFeaturesPlayManifestRelatedApplicationsOptions } from './FxIdWebFeaturesPlayManifestRelatedApplicationsOptions';
import {
    FxIdWebFeaturesPlayManifestRelatedApplicationsOptionsFromJSON,
    FxIdWebFeaturesPlayManifestRelatedApplicationsOptionsFromJSONTyped,
    FxIdWebFeaturesPlayManifestRelatedApplicationsOptionsToJSON,
    FxIdWebFeaturesPlayManifestRelatedApplicationsOptionsToJSONTyped,
} from './FxIdWebFeaturesPlayManifestRelatedApplicationsOptions';
import type { FxIdWebFeaturesPlayManifestResponseIcons } from './FxIdWebFeaturesPlayManifestResponseIcons';
import {
    FxIdWebFeaturesPlayManifestResponseIconsFromJSON,
    FxIdWebFeaturesPlayManifestResponseIconsFromJSONTyped,
    FxIdWebFeaturesPlayManifestResponseIconsToJSON,
    FxIdWebFeaturesPlayManifestResponseIconsToJSONTyped,
} from './FxIdWebFeaturesPlayManifestResponseIcons';

/**
 * Что может содержать в себе manifest.json файл.
 * Здесь представлены не все возможные поля.
 * @export
 * @interface FxIdWebFeaturesPlayManifestResponse
 */
export interface FxIdWebFeaturesPlayManifestResponse {
    /**
     * Схема для валидации manifest.json.
     * @type {string}
     * @memberof FxIdWebFeaturesPlayManifestResponse
     */
    $Schema: string;
    /**
     * Полное имя PWA.
     * Он появится вместе со значком на главном экране ОС, в панели запуска, на доке или в меню.
     * @type {string}
     * @memberof FxIdWebFeaturesPlayManifestResponse
     */
    Name: string;
    /**
     * Более короткое имя PWA.
     * Используется, когда недостаточно места для отображения полного значения name поля.
     * Рекомендуется не более 12 символов.
     * @type {string}
     * @memberof FxIdWebFeaturesPlayManifestResponse
     */
    ShortName?: string | null;
    /**
     * Иконки для значков запуска PWA.
     * Safari на iOS и iPadOS игнорирует это,
     * для них нужно указывать в link с rel apple-touch-icon на странице (Например, <link rel="apple-touch-icon" href="/icons/ios.png">)
     * @type {Array<FxIdWebFeaturesPlayManifestResponseIcons>}
     * @memberof FxIdWebFeaturesPlayManifestResponse
     */
    Icons?: Array<FxIdWebFeaturesPlayManifestResponseIcons> | null;
    /**
     * URL-адрес, который PWA должен загрузить, когда пользователь запускает его с установленного значка.
     * @type {string}
     * @memberof FxIdWebFeaturesPlayManifestResponse
     */
    StartUrl: string;
    /**
     * Область видимости приложения.
     * @type {string}
     * @memberof FxIdWebFeaturesPlayManifestResponse
     */
    Scope?: string | null;
    /**
     * Как ОС должна отображать окно PWA.
     * fullscreen, standalone, minimal-ui или browser.
     * @type {string}
     * @memberof FxIdWebFeaturesPlayManifestResponse
     */
    Display: string;
    /**
     * Строка для однозначной идентификации приложения.
     * Если не указано, используется start_url
     * (имеет смысл указывать, т.к. в случае изменения start_url браузер не определит, установлено ли приложение).
     * @type {string}
     * @memberof FxIdWebFeaturesPlayManifestResponse
     */
    Id?: string | null;
    /**
     * Цвет, отображаемый на фоне приложения перед загрузкой его стилей.
     * Safari на iOS и iPadOS игнорируют это поле.
     * @type {string}
     * @memberof FxIdWebFeaturesPlayManifestResponse
     */
    BackgroundColor?: string | null;
    /**
     * Описание, используется для рекламы.
     * @type {string}
     * @memberof FxIdWebFeaturesPlayManifestResponse
     */
    Description?: string | null;
    /**
     * Ориентация приложения.
     * @type {string}
     * @memberof FxIdWebFeaturesPlayManifestResponse
     */
    Orientation?: string | null;
    /**
     * Связанные нативные приложения.
     * @type {Array<FxIdWebFeaturesPlayManifestRelatedApplicationsOptions>}
     * @memberof FxIdWebFeaturesPlayManifestResponse
     */
    RelatedApplications?: Array<FxIdWebFeaturesPlayManifestRelatedApplicationsOptions> | null;
}

/**
 * Check if a given object implements the FxIdWebFeaturesPlayManifestResponse interface.
 */
export function instanceOfFxIdWebFeaturesPlayManifestResponse(value: object): value is FxIdWebFeaturesPlayManifestResponse {
    if (!('$Schema' in value) || value['$Schema'] === undefined) return false;
    if (!('Name' in value) || value['Name'] === undefined) return false;
    if (!('StartUrl' in value) || value['StartUrl'] === undefined) return false;
    if (!('Display' in value) || value['Display'] === undefined) return false;
    return true;
}

export function FxIdWebFeaturesPlayManifestResponseFromJSON(json: any): FxIdWebFeaturesPlayManifestResponse {
    return FxIdWebFeaturesPlayManifestResponseFromJSONTyped(json, false);
}

export function FxIdWebFeaturesPlayManifestResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesPlayManifestResponse {
    if (json == null) {
        return json;
    }
    return {
        
        '$Schema': json['$schema'],
        'Name': json['name'],
        'ShortName': json['short_name'] == null ? undefined : json['short_name'],
        'Icons': json['icons'] == null ? undefined : ((json['icons'] as Array<any>).map(FxIdWebFeaturesPlayManifestResponseIconsFromJSON)),
        'StartUrl': json['start_url'],
        'Scope': json['scope'] == null ? undefined : json['scope'],
        'Display': json['display'],
        'Id': json['id'] == null ? undefined : json['id'],
        'BackgroundColor': json['background_color'] == null ? undefined : json['background_color'],
        'Description': json['description'] == null ? undefined : json['description'],
        'Orientation': json['orientation'] == null ? undefined : json['orientation'],
        'RelatedApplications': json['related_applications'] == null ? undefined : ((json['related_applications'] as Array<any>).map(FxIdWebFeaturesPlayManifestRelatedApplicationsOptionsFromJSON)),
    };
}

export function FxIdWebFeaturesPlayManifestResponseToJSON(json: any): FxIdWebFeaturesPlayManifestResponse {
    return FxIdWebFeaturesPlayManifestResponseToJSONTyped(json, false);
}

export function FxIdWebFeaturesPlayManifestResponseToJSONTyped(value?: FxIdWebFeaturesPlayManifestResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        '$schema': value['$Schema'],
        'name': value['Name'],
        'short_name': value['ShortName'],
        'icons': value['Icons'] == null ? undefined : ((value['Icons'] as Array<any>).map(FxIdWebFeaturesPlayManifestResponseIconsToJSON)),
        'start_url': value['StartUrl'],
        'scope': value['Scope'],
        'display': value['Display'],
        'id': value['Id'],
        'background_color': value['BackgroundColor'],
        'description': value['Description'],
        'orientation': value['Orientation'],
        'related_applications': value['RelatedApplications'] == null ? undefined : ((value['RelatedApplications'] as Array<any>).map(FxIdWebFeaturesPlayManifestRelatedApplicationsOptionsToJSON)),
    };
}

